import * as actionTypes from "../_constants/auth.constants";
export function loginSucced(token) {
  return {
    type: actionTypes.LOGIN_SUCCESS,
    payload: { token }
  };
}
export function loginFailed(err) {
  return {
    type: actionTypes.LOGIN_FAILED,
    payload: err
  };
}
export function logutSucced() {
  return {
    type: actionTypes.LOGOUT_SUCCESS
  };
}
export function logoutFailed(err) {
  return {
    type: actionTypes.LOGOUT_FAILED,
    payload: err
  };
}
export function registerSucced(token, user) {
  return {
    type: actionTypes.REGISTER_SUCCESS,
    payload: { token, user }
  };
}
export function registerFailed(err) {
  return {
    type: actionTypes.REGISTER_FAILED,
    payload: err
  };
}
